import actionTypes from "./types";

export const updateTheme = (payload) => (dispatch) => {
    return dispatch({
        type: actionTypes.UPDATE_THEME,
        payload,
    });
};

export const updateSettings =
    (payload = {}, meta) =>
    (dispatch) => {
        const action = {
            type: actionTypes.UPDATE_SETTINGS,
            payload,
        };
        if (meta !== undefined) {
            action.meta = meta;
        }
        return dispatch(action);
    };

export const updateLastBackup = (payload) => (dispatch) => {
    return dispatch({
        type: actionTypes.UPDATE_LAST_BACKUP,
        payload,
    });
};

export const updateSyncStatus = (payload) => (dispatch) => {
    return dispatch({
        type: actionTypes.UPDATE_SYNC_STATUS,
        payload,
    });
};
